import React, { useState, useEffect } from 'react'
import { getData, postData } from '../../../actions/servicesHttp'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import MenuRS from './components/MenuRS'
import ParametersRS from './components/ParametersRS'
import DevicesRS from './components/DevicesRS'
import MessagesRS from './components/MessagesRS'
import ActionsRS from './components/ActionsRS'
import $ from 'jquery'
import styles from '../../../css/modals/ModalRSDevice.module.css'
import { showErrorDevice, showPopup } from '../../Popups/SweetAlertPopups'
import Loading from '../../generals/loading'
import { compareObjWithOutDate } from '../../generals/toolsFunctions'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import DeviceDataHeader from './components/DeviceDataHeader'

export default function ModalRSDevice ({ show, onHide, title, btnError, btnSuccess, data }) {
  const { t } = useTranslation('dashboardDevice')
  const navigate = useNavigate()
  const [rxartQueryUrl] = useState('rxartsecure/query_devices')
  const [changeRxDeviceData] = useState('rxartsecure/change_device_data')
  const [changeParams] = useState('rxartsecure/preferences')

  //* estados de componentes
  const [deviceRxartSecure, setDeviceRxartSecure] = useState(null)
  const [parametersRS, setParametersRS] = useState({})
  const [parametersRSToCompare, setParametersRSToCompare] = useState({})

  const [serialBiosDevice, setSerialBiosDevice] = useState('')
  const [loading, setLoading] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [titleBtnSuccess, setTitleBtnSuccess] = useState(btnSuccess)
  const [componentsModalRS, setComponentsModalRS] = useState({
    parameters: false,
    devices: false,
    messages: false,
    actions: false,
    menu: false
  })

  // Estados para mostrar o no los modales de Acciones
  const [modalsShow, setModalsShow] = useState({
    newTicket: false,
    statusHistory: false,
    ticketsIssued: false,
    activateLicense: false
  })

  // Menu
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (show) {
      setComponentsModalRS({
        menu: true,
        devices: true,
        parameters: false,
        messages: false,
        actions: false
      })
      setTitleBtnSuccess(t('modalRxartSecure.button2'))
      setActiveIndex(0)
    }
  }, [show])

  const getDeviceRS = async (url, rxartId, set, setLoading, setBios) => {
    try {
      setLoading(true)
      const devicesComponentsContainer = document.getElementById('devicesComponentsContainer')
      const response = await getData(`${url}/${rxartId}`, undefined, navigate)

      if (response.status === 200) {
        if (!response?.data?.device?.deviceId) {
          setIsModalVisible(false)
          showErrorDevice('question', t('modalRxartSecure.label1'), t('modalRxartSecure.label2'))
          onHide()
          return
        }

        const device = response?.data?.device
        device.license = device?.license ? device?.license : t('modalRxartSecure.label3')
        device.type = device?.deviceType?.toLowerCase()
        setIsModalVisible(true)
        set({
          device,
          preferences: response?.data?.preferences
        })
        setBios(response?.data?.device?.serialBios ? response?.data?.device?.serialBios : t('modalRxartSecure.label3'))
        if (devicesComponentsContainer) devicesComponentsContainer.style.display = 'block'

        setParametersRS(response?.data?.preferences)
        setParametersRSToCompare(response?.data?.preferences)

        return
      }

      if (response.code === 406) {
        setIsModalVisible(false)
        showErrorDevice('question', t('modalRxartSecure.label1'), t('modalRxartSecure.label4'))
        onHide()
      } else {
        setIsModalVisible(false)
        set({ error: true, code: response?.code })
        showErrorDevice('error', t('modalRxartSecure.label5'), t('modalRxartSecure.label6'))
        onHide()
      }
    } catch (error) {
      console.error({ error })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (show && data?.id_rxart) {
      const rxartId = data.id_rxart
      getDeviceRS(rxartQueryUrl, rxartId, setDeviceRxartSecure, setLoading, setSerialBiosDevice)
    }
  }, [show, data])

  //* llamados de la API cuco
  const changeParameters = async (data, deviceId, dataToCompare) => {
    $('#btnSucessModalRSDevice').prop('disabled', true)
    // console.log(data, deviceId, dataToCompare)
    const comparation = compareObjWithOutDate(data, dataToCompare)
    if (comparation) {
      showPopup('info', t('modalRxartSecure.label9'))
    } else {
      try {
        const json = {
          ...data,
          deviceId,
          type: 'custom'
        }
        const response = await postData(changeParams, json, navigate)
        if (response.status === 200) {
          showPopup('success', t('modalRxartSecure.label10'))
        } else {
          showPopup('error', t('modalRxartSecure.label11'))
        }
      } catch (error) {
        console.error({ error })
        showPopup('error', t('modalRxartSecure.label12'))
      }
    }

    $('#btnSucessModalRSDevice').prop('disabled', false)
    onHide()
  }

  const changeDeviceData = async (device, url, bios) => {
    $('#btnSucessModalRSDevice').prop('disabled', true)
    const body = {
      deviceid: device.deviceid,
      serialBios: device.serialBios,
      deviceType: device.deviceType,
      // newSerialBios: device?.serialBios !== bios.trim() ? bios.trim() : false,
      description: device?.description?.trim()
    }

    const response = await postData(`${url}/${device?.deviceId}`, body, navigate)
    if (response.status === 200) {
      showPopup('success', t('modalRxartSecure.label13'))
    } else {
      showPopup('error', t('modalRxartSecure.label14'))
    }
    $('#btnSucessModalRSDevice').prop('disabled', false)
    onHide()
  }

  const rxartSecure = (componentsModalRS, deviceRxartSecure, set, actions, setActions, bios) => {
    if (componentsModalRS?.parameters || componentsModalRS?.messages) {
      changeParameters(parametersRS, deviceRxartSecure?.device?.deviceId, parametersRSToCompare)
    } else if (componentsModalRS?.devices) {
      changeDeviceData(deviceRxartSecure, changeRxDeviceData, bios)
    }
  }

  return (
    <>
      {isModalVisible && (
        <Modal
          show={show}
          size="lg"
          onHide={onHide}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          id='modalRSDevice'
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              <i className={`pi pi-shield ${styles.iconTitle}`}></i>
              {t('modalRxartSecure.title')}
              <DeviceDataHeader data={deviceRxartSecure} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '0' } } >
            <div className={styles.devicesContainer} >
              <div className={styles.devicesComponentsContainer} id='devicesComponentsContainer' style={{ display: loading || !deviceRxartSecure ? 'none' : 'flex' }}>
                {deviceRxartSecure && componentsModalRS?.menu && <MenuRS data={deviceRxartSecure} componentsModalRS={componentsModalRS} setComponentsModalRS={setComponentsModalRS} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />}
                <div className={styles.componentContainer}>
                  {deviceRxartSecure && componentsModalRS?.devices && <DevicesRS data={deviceRxartSecure} setData={setDeviceRxartSecure} device={data} bios={serialBiosDevice} setBios={setSerialBiosDevice} setComponentsModalRS={setComponentsModalRS} setActiveIndex={setActiveIndex} modalsShow={modalsShow} setModalsShow={setModalsShow} close={() => onHide()}/>}
                  {deviceRxartSecure && componentsModalRS?.parameters && <ParametersRS parameters={parametersRS} setParameters={setParametersRS} device={deviceRxartSecure}/>}
                  {deviceRxartSecure && componentsModalRS?.messages && <MessagesRS messParams={parametersRS} setMessParams={setParametersRS} device={deviceRxartSecure}/>}
                  {deviceRxartSecure && componentsModalRS?.actions && <ActionsRS data={data} device={deviceRxartSecure} modalsShow={modalsShow} setModalsShow={setModalsShow} close={() => onHide()}/>}
                </div>
              </div>
              {(loading || !deviceRxartSecure) && <Loading color="primary" />}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onHide()} variant="danger">
              {btnError}
            </Button>
            {!componentsModalRS?.devices && !componentsModalRS?.actions && <Button onClick={() => rxartSecure(componentsModalRS, deviceRxartSecure, setDeviceRxartSecure, serialBiosDevice)} variant="primary" id="btnSucessModalRSDevice" >
              {titleBtnSuccess}
            </Button>}
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

ModalRSDevice.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  data: PropTypes.object
}
